import type { AxiosError, AxiosInstance } from 'axios';
import FormData from 'form-data';
import type { StatusResponseData } from '@/types/status';
import { handleAxiosError, errorHandler } from '@/api/utils';

const API_NAME = 'AWS - application';

export function sendApplication(apiInstance: AxiosInstance, params: any): Promise<StatusResponseData> {
  return errorHandler<StatusResponseData>(async () => ({
    data: (await apiInstance.post('/application', params)).data,
  })).catch((error: AxiosError) => {
    if (error.response?.data) {
      return {
        data: error.response.data,
      };
    }

    if (error?.name === 'AxiosError' && error?.code === 'ERR_NETWORK') {
      return {
        data: 'max_file_size',
      };
    }
    return {
      error: handleAxiosError(error, {
        api: API_NAME,
        method: 'sendApplication',
        params,
      }),
    };
  });
}

export function getApplicationPresignedUrlsData(
  apiInstance: AxiosInstance,
  fileNames: string[],
): Promise<StatusResponseData> {
  return errorHandler<StatusResponseData>(async () => ({
    data: (
      await apiInstance.post('/get-upload-urls', {
        filesNames: fileNames,
      })
    ).data,
  })).catch((error: AxiosError) => {
    if (error.response?.data) {
      return {
        data: error.response.data,
      };
    }
    return {
      error: handleAxiosError(error, {
        api: API_NAME,
        method: 'getApplicationPresignedUrlsData',
        fileNames: fileNames.join(','),
      }),
    };
  });
}

export async function s3UploadFile(apiInstance: AxiosInstance, fileUpload: any): Promise<any> {
  const data = new FormData();
  data.append('bucket', fileUpload.fields.bucket);
  data.append('x-amz-algorithm', fileUpload.fields['X-Amz-Algorithm']);
  data.append('x-amz-credential', fileUpload.fields['X-Amz-Credential']);
  data.append('x-amz-date', fileUpload.fields['X-Amz-Date']);
  data.append('X-Amz-Security-Token', fileUpload.fields['X-Amz-Security-Token']);
  data.append('key', fileUpload.fields.key);
  data.append('policy', fileUpload.fields.Policy);
  data.append('x-amz-signature', fileUpload.fields['X-Amz-Signature']);
  data.append('file', fileUpload.file);

  return await errorHandler<StatusResponseData>(async () => {
    const response = await apiInstance.post(fileUpload.url, data);
    // no response means success, 204
    if (response.status === 204) {
      return {
        data: {
          message: 'File uploaded successfully',
          file: fileUpload.fields.key,
        },
      };
    }
  }).catch(() => {
    return {
      error: 'max_file_size',
      message: 'File upload failed',
      code: 'max_file_size',
    };
  });
}
